import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../../../components/ui/dialog';
import { Button } from '../../../../components/ui/button';
import { Z_INDEX_CLASSES } from '../../../../constants/zIndex';

interface CancellationSuccessModalProps {
  open: boolean;
  onClose: () => void;
  cancelAt: string;
  message?: string;
}

export const CancellationSuccessModal: React.FC<
  CancellationSuccessModalProps
> = ({ open, onClose, cancelAt }) => {
  const { t } = useTranslation();
  const cancelDate = new Date(cancelAt).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className={`${Z_INDEX_CLASSES.nestedDialog} sm:max-w-[425px]`}
        overlayClassName={Z_INDEX_CLASSES.nestedDialogOverlay}
        onEscapeKeyDown={(e) => e.stopPropagation()}
        onInteractOutside={(e) => e.stopPropagation()}
      >
        <DialogHeader>
          <DialogTitle className="text-xl">
            {t('settings.billing.cancellation.success.title', 'All set')}
          </DialogTitle>
          <DialogDescription className="text-base">
            {t(
              'settings.billing.cancellation.success.description',
              `You'll keep full access until ${cancelDate}—nothing changes until then.`,
              {
                date: cancelDate,
              },
            )}
          </DialogDescription>
        </DialogHeader>

        <div className="py-2">
          <p className="text-sm text-muted-foreground">
            {t(
              'settings.billing.cancellation.success.reactivateNote',
              'Changed your mind? Reactivate anytime.',
            )}
          </p>
        </div>

        <DialogFooter>
          <Button onClick={onClose} className="w-full sm:w-auto">
            {t('settings.billing.cancellation.success.gotIt', 'Got it')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
